import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Linkedin, Mail } from "lucide-react";
const teamMembers = [{
  name: "Marcus Thorne",
  role: "Managing Partner",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/executive_marcus.png",
  bio: "Architect of the N2N Intelligence Engine with 20 years in quantitative venture capital and high-frequency systems design."
}, {
  name: "Elena Vance",
  role: "Director of Access",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/executive_elena.png",
  bio: "Leading global network expansion and strategic partnerships across emerging technology corridors and institutional hubs."
}, {
  name: "Julian Kross",
  role: "Chief Strategist",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/executive_julian.png",
  bio: "Pioneering the N2N Thesis on decentralized infrastructure, autonomous capital allocation, and protocol governance."
}];
export default function LeadershipTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}